var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatHeaderButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.36474 17.4258L2.34641 17.4442C2.09891 16.9033 1.94307 16.2892 1.87891 15.6108C1.94307 16.28 2.11724 16.885 2.36474 17.4258ZM8.24974 9.51501C8.82835 9.51501 9.38327 9.28515 9.79241 8.87601C10.2016 8.46687 10.4314 7.91195 10.4314 7.33334C10.4314 6.75473 10.2016 6.19981 9.79241 5.79067C9.38327 5.38153 8.82835 5.15167 8.24974 5.15167C7.67113 5.15167 7.11621 5.38153 6.70707 5.79067C6.29793 6.19981 6.06807 6.75473 6.06807 7.33334C6.06807 7.91195 6.29793 8.46687 6.70707 8.87601C7.11621 9.28515 7.67113 9.51501 8.24974 9.51501Z",
    fill: "#9498B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.8405 1.83331H7.15884C3.82217 1.83331 1.83301 3.82248 1.83301 7.15915V14.8408C1.83301 15.84 2.00717 16.7108 2.34634 17.4441C3.13467 19.1858 4.82134 20.1666 7.15884 20.1666H14.8405C18.1772 20.1666 20.1663 18.1775 20.1663 14.8408V7.15915C20.1663 3.82248 18.1772 1.83331 14.8405 1.83331ZM18.6722 11.4583C17.9572 10.8441 16.8022 10.8441 16.0872 11.4583L12.2738 14.7308C11.5588 15.345 10.4038 15.345 9.68884 14.7308L9.37717 14.4741C8.72634 13.9058 7.69051 13.8508 6.95717 14.3458L3.52884 16.6466C3.32717 16.1333 3.20801 15.5375 3.20801 14.8408V7.15915C3.20801 4.57415 4.57384 3.20831 7.15884 3.20831H14.8405C17.4255 3.20831 18.7913 4.57415 18.7913 7.15915V11.5591L18.6722 11.4583Z",
    fill: "#9498B6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatHeaderButton);
export default __webpack_public_path__ + "static/media/chatHeaderButton.c8895f40fa64b3c0f7b03f2c728fa0ad.svg";
export { ForwardRef as ReactComponent };